import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getAllContact = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/getAll`);
};

export const getAllContactLimit200 = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/getAllLimit200`);
};

export const getAllContactPagination = (page, limit) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/getAllPagination`, {
    params: {
      page,
      limit,
    },
  });
};

export const getAllContactPaginationByQuery = (
  page,
  limit,
  search,
  contact_type
) => {
  // console.log(`page = ${page}, limit = ${limit}, search = ${search}, contact_type = ${contact_type}`);

  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/getAllPagination`, {
    params: {
      page,
      limit,
      search,
      contact_type,
    },
  });
};

export const getAllContactPaginationBySort = (
  page,
  limit,
  search,
  contact_type,
  sortBy,
  sortDesc
) => {
  // console.log(`page = ${page}, limit = ${limit}, search = ${search}, contact_type = ${contact_type}`);

  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/getAllPagination`, {
    params: {
      page,
      limit,
      search,
      contact_type,
      sortBy,
      sortDesc,
    },
  });
};

export const getContactByContactType = (id) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/getByContact_type/${id}`);
};

export const createContact = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.CONTACT, data);
};

export const updateContact = (id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.CONTACT + `/${id}`, data);
};

export const deleteContact = (id) => {
  return httpClient.delete(`${trademark_const.trademark_url}/` + server.CONTACT + `/${id}`);
};

export const getMasterContactSearch = (query) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/searchdata`, query);
};

export const getMasterContactCheckcontactid = (id) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.CONTACT + `/checkcontactid/${id}`);
};
